<template>
  <!-- S1190-->
  <article>
    <div id="PAYMENT_GENERATION" class="container-fixed offset-bottom-4">
      <p v-if="showInfoText" class="offset-top-2" v-html="$t('payment.payment_generation_info_text')" />
      <VProgress class="offset-top-2 offset-bottom-2" :steps="steps" :active="activeStep" />
      <transition name="fade" mode="out-in" appear>
        <router-view></router-view>
      </transition>
    </div>
  </article>
</template>

<script>
import VProgress from '@/components/Progress';
import { PAYMENT_GENERATION, PAYMENT_GENERATION_CONFIRMATION, PAYMENT_GENERATION_DATA, PAYMENT_GENERATION_SUMMARY } from '@/router/route-types';
import { mapActions, mapState } from 'vuex';

const stepMap = {
  PAYMENT_GENERATION: 'payment.progress_product_selection',
  PAYMENT_GENERATION_DATA: 'payment.progress_product_data',
  PAYMENT_GENERATION_SUMMARY: 'payment.progress_product_summary',
  PAYMENT_GENERATION_CONFIRMATION: 'payment.progress_product_confirmation',
};

export default {
  name: 'PaymentGeneration',

  components: {
    VProgress,
  },

  computed: {
    ...mapState('payment', ['chargingNote', 'serviceId', 'validFormValues', 'xtcBookingResponse']),

    showInfoText() {
      return [PAYMENT_GENERATION, PAYMENT_GENERATION_DATA].includes(this.$route.name);
    },

    steps() {
      return Object.values(stepMap).map(s => ({ name: s }));
    },

    activeStep() {
      return stepMap[this.$route.name];
    },
  },

  watch: {
    $route(to) {
      this.checkRoute(to);
    },
  },

  created() {
    this.checkRoute(this.$route);
  },

  beforeDestroy() {
    this.reset();
  },

  methods: {
    ...mapActions('payment', ['reset']),

    checkRoute(targetRoute) {
      const open = name => this.$router.replace({ name });

      switch (targetRoute.name) {
        case PAYMENT_GENERATION:
          // always allow first page
          break;
        case PAYMENT_GENERATION_DATA:
          if (!this.serviceId) open(PAYMENT_GENERATION);
          if (!this.chargingNote) open(PAYMENT_GENERATION);
          break;
        case PAYMENT_GENERATION_SUMMARY:
          if (!this.validFormValues) open(PAYMENT_GENERATION_DATA);
          break;
        case PAYMENT_GENERATION_CONFIRMATION:
          if (!this.xtcBookingResponse) open(PAYMENT_GENERATION);
          break;
      }
    },
  },
};
</script>
